import axios, { AxiosPromise } from "axios";

export const FETCH_TEMPLATE_CONTENT = "AKASHA_FETCH_TEMPLATE_CONTENT";
export const FETCH_TEMPLATE_CONTENT_FULFILLED = `${FETCH_TEMPLATE_CONTENT}_FULFILLED`;
export const FETCH_TEMPLATE_CONTENT_REJECTED = `${FETCH_TEMPLATE_CONTENT}_REJECTED`;

interface GetTemplateContentActionMeta {
  languageCode: string;
  templateName: string;
  contentId?: string;
}

interface AxiosPromiseResponse {
  data: any;
}

interface GetTemplateContentAction {
  type: typeof FETCH_TEMPLATE_CONTENT;
  payload: AxiosPromise<AxiosPromiseResponse>;
  meta: GetTemplateContentActionMeta;
}

export interface GetTemplateContentActionResponse {
  type:
    | typeof FETCH_TEMPLATE_CONTENT_FULFILLED
    | typeof FETCH_TEMPLATE_CONTENT_REJECTED;
  payload: AxiosPromiseResponse;
  meta: GetTemplateContentActionMeta;
}

export function getTemplateContent(
  templateName: string,
  contentId?: string,
  languageCode: string = "en",
  fieldName?: string,
  additionalHeaders?: any
): GetTemplateContentAction {
  let templateContentUrl = `${process.env.REACT_APP_CMS_TEMPLATE_CONTENT_SERVICE_ENDPOINT}/${templateName}`;

  if (contentId !== undefined) {
    templateContentUrl += `/${contentId}?languageCode=${languageCode}`;
  }
  if (fieldName) {
    templateContentUrl += `&fieldToDecode=${fieldName}`;
  }
  return {
    type: FETCH_TEMPLATE_CONTENT,
    payload: axios.get(templateContentUrl, {
      headers: {
        ...additionalHeaders,
        "Customer-Facing-Tool": process.env.REACT_APP_CFT,
        CFT: process.env.REACT_APP_CFT,
        MSessionId: sessionStorage.getItem("sessionId"),
      },
    }),
    meta: { languageCode, templateName, contentId },
  };
}
